import { useMemo } from "react";
import { SaveButton, Toolbar } from "react-admin";
import { useFormContext, useWatch } from "react-hook-form";

const CustomToolbar = () => {
  const { control } = useFormContext();
  const [group_id, startingDate] = useWatch({ control, name: ["group_id", "startingDate"] });

  const disabled = useMemo(() => {
    return !group_id || !startingDate;
  }, [group_id, startingDate]);

  return (
    <Toolbar>
      <SaveButton label="Save" disabled={disabled} />
    </Toolbar>
  );
};

export default CustomToolbar;
